module.exports = __webpack_public_path__ + "img/careers-work-happily.6c7366b9.svg";